/* Living Oceans — Footer Banners
   Per-instance, idempotent, theme-editor safe init.
   Reveals each banner card on scroll with a small stagger. */
(function () {
  var SELECTOR = '[data-section-type="footer-banners"]';
  var supportsIO = typeof window !== 'undefined' && 'IntersectionObserver' in window;
  var prefersReduced = typeof window !== 'undefined'
    && window.matchMedia
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function reveal(card, index) {
    if (!card) return;
    // Small per-card delay for a gentle stagger
    card.style.transitionDelay = (Math.min(index, 4) * 90) + 'ms';
    card.classList.add('is-visible');
  }

  function init(section) {
    if (!section || section.dataset.fbBound === 'true') return;
    section.dataset.fbBound = 'true';

    var cards = section.querySelectorAll('[data-fb-card]');

    if (prefersReduced || !supportsIO) {
      cards.forEach(function (card, i) { reveal(card, i); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var card = entry.target;
        var idx = Array.prototype.indexOf.call(cards, card);
        reveal(card, idx < 0 ? 0 : idx);
        observer.unobserve(card);
      });
    }, {
      root: null,
      rootMargin: '0px 0px -10% 0px',
      threshold: 0.15
    });

    cards.forEach(function (card) { observer.observe(card); });

    section._fbCleanup = function () {
      observer.disconnect();
      cards.forEach(function (card) {
        card.style.transitionDelay = '';
        card.classList.remove('is-visible');
      });
    };
  }

  function destroy(section) {
    if (!section) return;
    if (typeof section._fbCleanup === 'function') section._fbCleanup();
    section.dataset.fbBound = '';
  }

  function bootAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bootAll(); });
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var target = e.target;
    if (!target) return;
    if (target.matches && target.matches(SELECTOR)) init(target);
    bootAll(target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var target = e.target;
    if (!target) return;
    if (target.matches && target.matches(SELECTOR)) destroy(target);
    (target.querySelectorAll ? target.querySelectorAll(SELECTOR) : []).forEach(destroy);
  });
})();
